import {isJudge, isPartner, isReader, isStaff} from './role';

// Navigation only. Blog verifies the session and resource ownership again.
export function getMigratedPortal(user) {
  const memberType = String(user?.memberType || '').toUpperCase();
  if (memberType === 'TEAM' || isJudge(user?.roles)) return null;
  if (memberType === 'COMPANY') return 'partner';
  if (memberType === 'MEMBER') return 'reader';
  if (isStaff(user?.roles)) return null;
  if (isPartner(user?.roles)) return 'partner';
  if (isReader(user?.roles)) return 'reader';
  return null;
}

export function getLegacyPortalTarget(portal, pathname, baseUrl) {
  const url = new URL(baseUrl);
  const host = url.hostname.replace(/^(system|panel|dashboard)\./, '');
  if (host === 'jidipi.com' || host.endsWith('.jidipi.com') || host === 'jidipi.local') {
    url.hostname = `${portal === 'reader' ? 'panel' : 'dashboard'}.${host}`;
  }
  const path = (pathname || '/').replace(/\/+$/, '') || '/';
  let target = '/dashboard/partner/overview';
  if (portal === 'reader') {
    target = '/panel/post/mine';
    if (path === '/fav-company') target = '/panel/company/all';
    if (path === '/fav-information-posts') target = '/panel/information/mine';
    if (path.startsWith('/showroom')) target = '/panel/showroom';
  } else if (path === '/partner/login') {
    target = '/login';
  } else if (/^\/account(?:\/|$)/.test(path)) {
    target = '/dashboard/partner/account/profile';
  } else if (/^\/cloud(?:\/|$)/.test(path)) {
    target = '/dashboard/cloud/unconnected';
  } else if (/^\/post\/view\/[^/]+$/.test(path)) {
    target = `/dashboard/post/${path.split('/').pop()}`;
  } else if (path === '/showroom/add') {
    target = '/dashboard/partner/showroom/new';
  } else if (/^\/showroom\/edit\/[^/]+$/.test(path)) {
    target = `/dashboard/partner/showroom/${path.split('/').pop()}/edit`;
  } else if (path === '/showroom' || /^\/showroom\/(events|rooms|hosts|members|packages)$/.test(path)) {
    target = '/dashboard/partner/showroom';
  } else if (/^\/showroom\/(viewers|requests|approvals)$/.test(path)) {
    target = `/dashboard/partner/showroom/${path.split('/').pop().replace('approvals', 'requests')}`;
  } else if (/^\/showroom\/[^/]+(?:\/(viewers|requests|approvals|chat|grants\/send))?$/.test(path)) {
    const suffix = path.slice('/showroom/'.length).replace(/\/grants\/send$/, '/grants').replace(/\/approvals$/, '/requests');
    target = `/dashboard/partner/showroom/${suffix}`;
  }
  // Do not carry legacy company IDs, session query strings or external redirects.
  url.pathname = target;
  url.search = '';
  url.hash = '';
  return url.href;
}
